// Configuration file for API URLs and settings
// Change this when deploying to production

const config = {
    // API Configuration
    API_BASE_URL: "https://admin.easyque.eu/api",

    // Frontend URLs (for navigation)
    FRONTEND_BASE_URL: "https://admin.easyque.eu",
    
    // User Frontend URL (for public-facing content like carousels)
    USER_FRONTEND_BASE_URL: "https://easyque.eu",

    // Environment
    ENV: process.env.NODE_ENV || "production",

    // Timezone Configuration
    TIMEZONE: "Europe/Oslo", // Set to your local timezone

    // Feature flags
    FEATURES: {
        DEMO_MODE: false,
        REAL_TIME_UPDATES: true,
        REPORTS: true,
    },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
    return `${config.API_BASE_URL}${endpoint}`;
};

// Helper function to get full frontend URL
export const getFrontendUrl = (path) => {
    return `${config.FRONTEND_BASE_URL}${path}`;
};

// Helper function to get user frontend URL (for public-facing content)
export const getUserFrontendUrl = (path) => {
    return `${config.USER_FRONTEND_BASE_URL}${path}`;
};

// Helper function to add cache-busting parameter
export const addCacheBuster = (url) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_cb=${Date.now()}`;
};

// Helper function to force page reload without cache
export const forceReload = () => {
    if (window.location.reload) {
        window.location.reload(true); // Force reload from server
    } else {
        window.location.href = window.location.href;
    }
};

// Helper function to format date/time in local timezone
export const formatLocalDateTime = (dateString, options = {}) => {
    const defaultOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: config.TIMEZONE
    };
    
    const formatOptions = { ...defaultOptions, ...options };
    
    try {
        const date = new Date(dateString);
        return date.toLocaleString('no-NO', formatOptions); // Norwegian locale
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
    }
};

// Helper function to get current time in local timezone
export const getCurrentLocalTime = () => {
    return new Date().toLocaleString('no-NO', {
        timeZone: config.TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};

export default config;